import React, { useEffect, useState } from 'react';
import { PostJson } from '@awp/helpers/fetchReact';
import { FORM_MODE, Permissions, REST_API } from '@awp/constants';
import { Card, Container, Row } from 'react-bootstrap';
import { Form, Formik } from 'formik';
import { toast } from 'react-toastify';
import AwpValidationErrorModal from '@awp/components/Common/AwpValidationErrorModal';
import AwpFormActionButtons from '@awp/components/Common/AwpFormActionButtons';
import AwpSpinner from '@awp/components/Common/AwpSpinner';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AwpContainer } from '@components/Common/AwpContainer';
import Authorize from '@components/Authorize';
import { getListPageParams } from '@awp/helpers/navigation';
import { AvalancheProgramsService } from '@components/AvalanchePrograms/AvalancheProgramsService';
import { fetchPrograms, selectAllPrograms } from '@stores/avalancheDashboardViewPageSlice';
import { isPristine } from '@awp/helpers/UIHelper';

const AvalancheProgramCreate = () => {
  const [entityErrors, setEntityErrors] = useState(null);
  const [loading, setLoading] = useState(false);
  const [initialDto, setInitialDto] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const avalancheProgramsService = new AvalancheProgramsService(FORM_MODE.CREATE);
  const { readOnly, title, buttonLabel, relativePath, entityName, successMessage } = avalancheProgramsService.crud;

  const listPageURL = getListPageParams();
  const allEntities = useSelector(selectAllPrograms);
  const mapDTO = (x) => {
    return {
      ...AvalancheProgramsService.mapInitialValues(x),
    };
  };
  useEffect(() => {
    setLoading(true);
    setInitialDto(
      mapDTO({
        Name: '',
        Code: '',
        IsActive: true,
      }),
    );
    dispatch(fetchPrograms());
  }, []);

  useEffect(() => {
    if (allEntities.length) {
      setLoading(false);
    }
  }, [allEntities]);

  const handleSubmit = (values, { setSubmitting, resetForm, setErrors }) => {
    setSubmitting(true);

    createEntity(setSubmitting, setErrors, {
      ...AvalancheProgramsService.mapFormToDTO(values),
    });
  };

  const createEntity = (setSubmitting, setErrors, entityDto) => {
    PostJson(REST_API.AVA_MONITOR_PROGRAMS, entityDto)
      .then(async (response) => {
        if (response.ok) {
          const responseData = await response.json();
          setInitialDto(mapDTO(responseData));
          toast.success(successMessage);
          navigate(`${relativePath}${FORM_MODE.VIEW}/${responseData.Id}`);
        } else if (response.status === 412) {
          const errors = await response.json();
          setErrors(errors);
          if (errors.entity) setEntityErrors({ Entity: errors.entity });
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const onClickCancel = () => {
    navigate(`${relativePath}${listPageURL}`);
  };

  return (
    <>
      <AwpContainer>
        <Authorize requires={[Permissions.WriteAdminTools]}>
          {loading ? (
            <Container>
              <AwpSpinner />
            </Container>
          ) : (
            <>
              <Formik
                initialValues={mapDTO({
                  Name: '',
                  Code: '',
                  IsActive: true,
                })}
                validateOnMount={true}
                validationSchema={AvalancheProgramsService.getValidations({ data: {}, allEntities })}
                onSubmit={handleSubmit}
              >
                {(props) => (
                  <Form>
                    <Link className="awp-text-btn" to={`${relativePath}${listPageURL}`}>
                      {`List ${entityName}`}
                    </Link>
                    <span className="mx-3">&gt;</span>
                    <span>{title}</span>
                    <Card border="light" className="page-card">
                      <Card.Header>
                        <Row className="mt-4"></Row>
                        {avalancheProgramsService.crud.getHeader()}
                      </Card.Header>
                      <Card.Body>
                        {AvalancheProgramsService.getFields({
                          readOnly,
                        })}
                      </Card.Body>
                      <Card.Footer>
                        <Row className="my-2">
                          <AwpFormActionButtons
                            title=" "
                            id={2}
                            entityName={entityName}
                            buttonLabel={buttonLabel}
                            mode={FORM_MODE.CREATE}
                            onClickCancel={onClickCancel}
                            permissions={[Permissions.WriteAdminTools]}
                            readOnly={readOnly}
                            isAlignLeft={true}
                            btnCancelName={'Close'}
                            props={props}
                            isPristine={isPristine(props.values, initialDto)}
                          />
                        </Row>
                      </Card.Footer>
                    </Card>
                  </Form>
                )}
              </Formik>
              <AwpValidationErrorModal setErrors={setEntityErrors} errors={entityErrors} />
            </>
          )}
        </Authorize>
      </AwpContainer>
    </>
  );
};

export default AvalancheProgramCreate;
